import {
  AccountSettingState,
  CarrierInformationForm,
  SmtpForm,
  VbusDeviceState,
} from '../types';

export const accountSettingState: AccountSettingState = {
  accountProperties: [],
  defaultUserPreferences: [],
  vbusDevices: [],
  reasonList: [],
  hiddenReports: [],
};

export const initialcarrierInformationForm: CarrierInformationForm = {
  updateFrequency: {
    name: '',
    value: '',
    edit: false,
  },
  aobrdSpeedThreshold: {
    name: '',
    value: '',
    edit: false,
  },
  eldSpeedThreshold: {
    name: '',
    value: '',
    edit: false,
  },
  emailServiceProvider: {
    name: '',
    value: '',
    edit: false,
  },
  showPersonalConveyance: {
    name: '',
    value: false,
    edit: false,
  },
  showYardMoves: {
    name: '',
    value: false,
    edit: false,
  },
  driverAssetAdminDefault: {
    name: '',
    value: false,
    edit: false,
  },
  allowDriverToDeleteAsset: {
    name: '',
    value: false,
    edit: false,
  },
  carrierInformationEdit: {
    name: '',
    value: false,
    edit: false,
  },
  selectRegulationMode: {
    name: '',
    value: false,
    edit: false,
  },
  aobrdDisplayStreetAddress: {
    name: '',
    value: false,
    edit: false,
  },
  showOffRoad: {
    name: '',
    value: false,
    edit: false,
  },
  showTollRoad: {
    name: '',
    value: false,
    edit: false,
  },
  onDutyTimeRefund: {
    name: '',
    value: false,
    edit: false,
  },
  allowCycleChange: {
    name: '',
    value: false,
    edit: false,
  },
  showCertifiedLogDvir: {
    name: '',
    value: false,
    edit: false,
  },
  defaultLogsPageToDriversTimezone: {
    name: '',
    value: false,
    edit: false,
  },
  logsEditingMode: {
    name: '',
    value: '',
    edit: false,
  },
  androidMessage: {
    name: '',
    value: '',
  },
  iosMessage: {
    name: '',
    value: '',
  },
};

export const initialSmtpConfigurationForm: SmtpForm = {
  smtpEnable: false,
  serverUrl: '',
  portNumber: undefined,
  username: '',
  password: '',
  action: 'POST',
  isDisabled: true,
  id: undefined,
  alertEmailFrom: {
    name: 'noreply@vistracks.com',
    value: '',
    id: undefined,
  },
  notificationEmailFrom: {
    name: 'noreply@vistracks.com',
    value: '',
    id: undefined,
  },
  verificationEmailSubject: {
    name: 'verification.email.subject',
    value: '',
    id: undefined,
  },
  verificationEmailMessage: {
    name: 'verification.email.message',
    value: '',
    id: undefined,
  },
  passwordEmailSubject: {
    name: 'password.email.message',
    value: '',
    id: undefined,
  },
  passwordEmailMessage: {
    name: 'password.email.subject',
    value: '',
    id: undefined,
  },
  smtpTls: false,
};

export const initialVbusDeviceState: VbusDeviceState[] = [];
